<template>
  <div class="p-home">
    <div class="p-home-content">
      <!-- 大数据搜索框 B类账号隐藏大数据搜索框-->
      <template v-if="userType !== 'B' && hasPermissionForTools">
        <data-base-search></data-base-search>
      </template>
      <!-- 待办任务 -->
      <todo-schedule></todo-schedule>
      <!-- 日程 -->
      <daily-schedule></daily-schedule>
      <!-- 全部动态, 平台版隐藏该组件 -->
      <template v-if="officetype !== 'platform'">
        <dynamicLogs></dynamicLogs>
      </template>
    </div>
    <div class="p-home-sidebar">
      <!-- 精选内容 -->
      <exquisite-content></exquisite-content>
      <!-- 快捷操作 -->
      <shortcut-operate></shortcut-operate>
      <!-- 计时 -->
      <todayTiming></todayTiming>
      <!-- 最近浏览 -->
      <recently-browse></recently-browse>
    </div>
  </div>
</template>
<script>
// const DataBaseSearch = () => import('../components/dataBaseSearch/dataBaseSearch')
// const TodoSchedule = () => import('../components/todoSchedule/todoSchedule')
// const DailySchedule = () => import('../components/dailySchedule/dailySchedule')
// const ExquisiteContent = () => import('../components/exquisiteContent/exquisiteContent')
// const shortcutOperate = () => import('../components/shortcutOperate/shortcutOperate')
// const RecentlyBrowse = () => import('../components/recentlyBrowse/recentlyBrowse')
// const todayTiming = () => import('../components/todayTiming/todayTiming')
// const dynamicLogs = () => import('../components/dynamicLogs/dynamicLogs')

import DataBaseSearch from '../components/dataBaseSearch/dataBaseSearch'
import TodoSchedule from '../components/todoSchedule/todoSchedule'
import DailySchedule from '../components/dailySchedule/dailySchedule'
import ExquisiteContent from '../components/exquisiteContent/exquisiteContent'
import shortcutOperate from '../components/shortcutOperate/shortcutOperate'
import RecentlyBrowse from '../components/recentlyBrowse/recentlyBrowse'
import todayTiming from '../components/todayTiming/todayTiming'
import dynamicLogs from '../components/dynamicLogs/dynamicLogs'
import indexService from '../service/index'
export default {
  name: 'PHomeView',
  components: {
    RecentlyBrowse,
    DataBaseSearch,
    TodoSchedule,
    DailySchedule,
    ExquisiteContent,
    shortcutOperate,
    todayTiming,
    dynamicLogs
  },
  data () {
    return {
      userType: '',
      officetype: '', // 平台版还是团队版
      hasPermissionForTools: false // 工具大数据权限
    }
  },
  mounted () {
    this.initStatus()
    // 获取是否有大数据搜索权限
    this.getToolsPermissionForBigData()
  },
  methods: {
    initStatus () {
      this.userType = localStorage.getItem('userType')
      this.officetype = localStorage.getItem('officetype')
    },
    async getToolsPermissionForBigData () {
      let response = null
      response = await indexService.getToolsPermissionForBigData()
      if (response.isSuccess) {
        this.hasPermissionForTools = response.data
      } else {
        this.$message(response.resultMsg)
      }
    }
  }
}
</script>
<style lang="stylus">
.p-home
  display flex
  // 为了iframe不出横向滚动条，这里不需要设置宽度
  // width 1000px
  // margin 0 auto
  flex-direction row
  &-content
    flex 1
  &-sidebar
    width 280px
    // width 330px
    border-left 1px solid #ECECEC
  &-content,
  &-sidebar
    &>div
      border-top 1px solid #ECECEC
      &:first-child
        border-top 0
</style>
